export function capitalizeFirstLetter(entry: string) {
  entry = entry.toLowerCase();
  return entry.charAt(0).toUpperCase() + entry.slice(1);
}

export function slugify(entry: string) {
  return entry.toLowerCase().replace(/\s/g, '-');
}
